import { render, staticRenderFns } from "./clientUpdate.vue?vue&type=template&id=fd56b2d6"
import script from "./clientUpdate.vue?vue&type=script&lang=js"
export * from "./clientUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports